
export const hasError = (resultData) => {
  return resultData.detail != null;
};

export const getError = (resultData) => {
  return resultData.detail;
};


// converts object to yyyy-mm-dd
export const formatDayJsDate = (dayJsObj) => {
  return dayJsObj.format("YYYY-MM-DD");
};

export const doService = (
  promise,
  okFunction,
  failFunction = null,
  catchFunction = null,
  finallyFunction = null
) => {
  return promise
    .then((result) => {
      if (hasError(result) === true) {
        console.log(result);
        window.showSnack("Unable to Process Request: " + getError(result));

        if (failFunction != null) {
          failFunction(result.detail);
        }
        return;
      }
      okFunction(result);
    })
    .catch((error) => {
      if (catchFunction != null) {
        catchFunction(error);
      } else {
        window.showSnack("Unable to Process Request");
        console.log(error.stack);
      }
    })
    .finally(() => {
      if (finallyFunction != null) {
        finallyFunction();
      }
    });
};

export const getArrayValues = (arr) => {
  return arr.map((item) => item.value);
};